<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="formValues">
      <div class="uk-modal-header form-header">
        <span class="uk-text-bold uk-text-large">トライアル発行</span>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="clientName" v-slot="{ field }">
            <FieldLabel title="クライアント名" :required="true" />
            <input class="uk-input" type="text" v-bind="field" />
          </Field>
          <FieldError name="clientName" />
        </div>
        <div class="field">
          <Field name="maxEmployees" v-slot="{ field }">
            <FieldLabel title="上限従業員数" :required="true" />
            <input class="uk-input max-employees" type="text" v-bind="field" />
          </Field>
          <FieldError name="maxEmployees" />
        </div>
        <div class="field">
          <Field name="departmentNames">
            <FieldLabel title="部署名" />
            <Multiselect class="multiselect-blue" v-model="departmentNames" v-bind="departmentOptions" />
          </Field>
          <FieldError name="departmentNames" />
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".trial-form-modal" />
        </div>
        <div class="form-action-main">
          <ActionButton title="完了" color="primary" type="submit" :disabled="processing" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss" scoped>
@include modal-form;
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import FormMixin from "../../helpers/mixins/form";
import { SystemApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import Multiselect from "@vueform/multiselect";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  clientName: string;
  departmentNames: [];
  maxEmployees: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError, Multiselect }
})
export default class TrialAccountForm extends FormMixin {
  formName = "トライアル発行";
  defaultMaxEmployees = 3;
  departmentNames = [];
  departmentOptions = {
    ...this.multiSelectBaseOptions,
    max: 3,
    options: [],
    createOption: true
  };
  formValues: FormValues = {
    clientName: "",
    departmentNames: [],
    maxEmployees: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      clientName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "クライアント名" })),
      maxEmployees: yup.string().required(this.$t("input_required", { field: "上限従業員数" }))
    });
  }
  async onBeforeSubmit(formValues: FormValues) {
    await this.onSubmit(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const submitValues = {
        clientName: formValues.clientName,
        departmentNames: this.departmentNames,
        maxEmployees: formValues.maxEmployees
      };
      await new SystemApi().createTrialAccount({
        createTrialAccountRequest: submitValues
      });
      this.$emit("submitted");
    });
  }
}
</script>
